import React, { FC } from 'react';
import { NavbarElementProps } from 'react-day-picker';
import styled from 'styled-components';

import CalendarArrowLeft from 'assets/img/calendar-arrow-left.svg';
import CalendarArrowRight from 'assets/img/calendar-arrow-right.svg';

const MonthsNav: FC<NavbarElementProps> = ({
  nextMonth,
  previousMonth,
  onPreviousClick,
  onNextClick,
  className,
  localeUtils,
  classNames,
  labels,
  locale,
  month,
  showNextButton,
  showPreviousButton,
}) => {
  return (
    <>
      {showPreviousButton && (
        <button
          type="button"
          onClick={() => onPreviousClick()}
          className="calendar-button"
        >
          <img
            src={CalendarArrowLeft}
            alt="Mês anterior"
            className="leftArrow"
          />
        </button>
      )}

      <button
        type="button"
        className="calendar-button"
        onClick={() => onNextClick()}
      >
        <img
          src={CalendarArrowRight}
          alt="Próximo mês"
          className="rightArrow"
        />
      </button>
    </>
  );
};

export default MonthsNav;
